import { ChangeEvent } from 'react'
import { AutocompleteFreeSoloValueMapping } from '@mui/material'
import { useField } from 'formik'
import { Autocomplete, AutocompleteProps } from '@dhl/components'

type Props<T, FreeSolo extends boolean | undefined> = Pick<
  AutocompleteProps<T, FreeSolo>,
  'label' | 'fullWidth' | 'margin' | 'placeholder' | 'size'
> & {
  name: string
  options: T[]
  getOptionLabel: (option: T | AutocompleteFreeSoloValueMapping<FreeSolo>) => string
  getOptionValue: (option: T | AutocompleteFreeSoloValueMapping<FreeSolo>) => string | null
  groupBy?: (option: T) => string
  freeSolo?: FreeSolo
  autoFocus?: boolean
  clearable?: boolean
  selectOnFocus?: boolean
  autoHighlight?: boolean
  disabled?: boolean
  required?: boolean
}

// @deprecated Use `AutocompleteInput` from @dhl/inputs instead (slightly different API)
export function AutocompleteInput<T, FreeSolo extends boolean | undefined>({
  name,
  options,
  getOptionValue,
  freeSolo,
  ...props
}: Props<T, FreeSolo>) {
  const [field, meta, helpers] = useField<string | null>(name)
  const value = options.find((option) => getOptionValue(option) === field.value) || null

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const onChange = (e: ChangeEvent<{}>, value: null | T | AutocompleteFreeSoloValueMapping<FreeSolo>) =>
    helpers.setValue(value && getOptionValue(value))

  return (
    <Autocomplete<T, FreeSolo>
      {...props}
      name={name}
      freeSolo={freeSolo}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      value={freeSolo ? (field.value as any) : value}
      onChange={onChange}
      id={field.name}
      error={!!meta.error && meta.touched}
      helperText={meta.touched && meta.error}
      options={options}
    />
  )
}
